import {AbsoluteFill} from 'remotion';

export const Green: React.FC = () => {
	return (
		<AbsoluteFill
			style={{
				backgroundColor: '#008000',
			}}
		/>
	);
};
